import * as React from "react";

const MOBILE_BREAKPOINT = 768;
const MOBILE_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

export function useIsMobile(): boolean {
	// Read the query during the first render, so a phone does not render the
	// desktop shell first and swap it out once the effect below runs.
	const [isMobile, setIsMobile] = React.useState<boolean>(
		() => window.matchMedia(MOBILE_QUERY).matches,
	);

	React.useEffect(() => {
		const mql = window.matchMedia(MOBILE_QUERY);
		const onChange = (): void => {
			setIsMobile(mql.matches);
		};
		mql.addEventListener("change", onChange);
		onChange();
		return () => mql.removeEventListener("change", onChange);
	}, []);

	return isMobile;
}
